import Qs from 'qs';
import store from '../store';
const $axios = require('../axios/axios');
import $api from '@/axios/api';
import { AES_Encrypt, AES_Decrypt } from '@/utils/encryp.js';
import $store from '@/store/index';
import $route from '@/router/index';
import i18n from '@/utils/i18n/index';
import { languageKey, defaultLang } from '@/utils/i18n/lang.config.js';
//指纹id
import Fingerprint2 from 'fingerprintjs2';

/**
 * 生成sign
 * sign - Encryption and decryption rules
 * Sign encryption/decryption key：@ALCHEMY$VPG!J8vq
 * Sign encryption/Decryption algorithm：通过AES/ECB/PKCS5Padding
 * The content of the generated sign is：userId - Last 5 digits of userno - timestamp，eg：12345678-12345-1645427147261
 * After successful decryption and login，You can get userId from sign,Remove the ACh from the decrypted content of the sign is userId，
 * @returns {Object}
 */
export function generateSign() {
  let obj = {
    sign: '',
    timestamp: new Date().getTime()
  };
  if (window.localStorage.getItem('token') && window.localStorage.getItem('userId') && window.localStorage.getItem('userNo')) {
    let text = window.localStorage.getItem('userId');
    let userId = text.substring(text.lastIndexOf('H') + 1, text.length);
    let userNo = window.localStorage.getItem('userNo').substring(localStorage.getItem('userNo').length - 5);
    obj.timestamp = new Date().getTime();
    obj.sign = AES_Encrypt(userId + '-' + userNo + '-' + obj.timestamp);
    window.localStorage.setItem('sign', obj.sign);
    return obj;
  }
  return obj;
}

/**
 * 提交订单、确认订单前获取submit-token公共接口
 * @returns 获取成功返回true，失败则是fasle
 */
export async function querySubmitToken() {
  let params = {
    coin: store.state.faitBuyPage.cryptoInfo.crypto,
    email: localStorage.getItem('email')
  };
  //二次支付修改币种
  if ($route.history.current.query.pathHistry === 'tradeHistory') {
    params.coin = store.state.secondaryBuyPayments.buyPayment_secondPay.cryptoCurrency;
  }
  return await $axios.default
    .post($api.post_submitToken, params, '')
    .then(res => {
      return res && res.data !== null && res.data ? true : false;
    })
    .catch(() => {
      return false;
    });
}

/**
 * 获取设备指纹id
 * fingerprint - 设备指纹 ｜ 设备唯一id
 * @url https://dashboard.fingerprint.com
 */
export async function fingerprintId() {
  return await new Promise(resolve => {
    return Fingerprint2.get(function (components) {
      const values = components.map(function (component, index) {
        if (index === 0) {
          //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
          return component.value.replace(/\bNetType\/\w+\b/, '');
        }
        return component.value;
      });
      // 生成最终id murmur
      let id = Fingerprint2.x64hash128(values.join(''), 31);
      window.localStorage.setItem('fingerprint_id', AES_Encrypt(id));
      resolve(AES_Encrypt(id));
    });
  });
}
/**
 * 生成日本通道token
 * @param cardno - 卡号
 * @param expire - 年月 eg: 2209
 * @returns {Promise<token>}
 */
export function japaneseToken(cardno, expire) {
  let newToken = new Promise(resolve => {
    window.Multipayment.init('9200004239555'); //トークンを利用するための a    pi キー
    window.Multipayment.getToken(
      {
        cardno: cardno, //加盟店様の購入フォームから取得したカード番号
        expire: expire, //加盟店様の購入フォームから取得したカード有効期限
        tokennumber: '5' //加盟店様の購入フォームから取得したトークン発行数
      },
      function (response) {
        if (response.resultCode !== '000') {
          resolve(false);
        } else {
          resolve(response);
        }
      }
    );
  });
  return newToken;
}

/**
 * hash路由模式获取不到参数问题
 * @returns {Object} - router query、router fullPath
 */
export function hashQuery() {
  let routerObject = {
    query: {},
    fullPath: ''
  };
  if ($route.currentRoute.fullPath !== '/index') {
    routerObject.fullPath = $route.currentRoute.fullPath.substring(2, $route.currentRoute.fullPath.length);
    routerObject.query = $route.currentRoute.query;
  }
  if (location.search !== '') {
    routerObject.fullPath = location.search.substring(1, location.search.length);
    const index = location.search.indexOf('?');
    if (index === -1) return {};
    const params = location.search.slice(index + 1);
    routerObject.query = Qs.parse(params);
  }
  return routerObject;
}

/**
 * 获取商户信息
 */
export function merchantInfo() {
  //获取地址栏信息
  let routeInfo = JSON.parse(JSON.stringify(hashQuery()));
  let routeQuery = routeInfo.query;
  let buyMerchantInfo = JSON.parse(sessionStorage.getItem('buyMerchantInfo'));
  let store_buyMerchantInfo;
  if (routeInfo.fullPath) {
    store_buyMerchantInfo = routeQuery;
    store_buyMerchantInfo.merchantParam = routeInfo.fullPath;
    // 商户没有携带type、showTable
    if (!routeQuery.type && !routeQuery.showTable && routeQuery.appId) {
      store_buyMerchantInfo.type = 'buy';
      store_buyMerchantInfo.showTabble = 'buy';
      $store.state.tableState = true;
      $store.state.homeTabstate = 'buyCrypto';
    }
    // 商户携带type、没有携带showTable
    if (routeQuery.type && routeQuery.type === 'buy' && !routeQuery.showTable && routeQuery.appId) {
      store_buyMerchantInfo.type = 'buy';
      store_buyMerchantInfo.showTabble = 'buy';
      $store.state.tableState = true;
      $store.state.homeTabstate = 'buyCrypto';
    }
    // 商户没有携带type、携带showTable
    if (!routeQuery.type && routeQuery.showTable && routeQuery.showTable === 'buy' && routeQuery.appId) {
      store_buyMerchantInfo.type = 'buy';
      store_buyMerchantInfo.showTabble = 'buy';
      $store.state.tableState = true;
      $store.state.homeTabstate = 'buyCrypto';
    }
  } else if (!routeInfo.fullPath && buyMerchantInfo) {
    store_buyMerchantInfo = buyMerchantInfo;
  } else {
    store_buyMerchantInfo = {};
  }
  // routeQuery.appId = routeQuery.appId !== undefined && routeQuery.appId ? routeQuery.appId : buyMerchantInfo !== null ? buyMerchantInfo.appId : '';
  sessionStorage.setItem('buyMerchantInfo', JSON.stringify(store_buyMerchantInfo));

  //兼容商户多语言功能
  if (routeQuery.language) {
    let language = defaultLang;
    if (routeQuery.language === 'en') {
      language = defaultLang;
    } else {
      if (routeQuery.language && languageKey.includes(routeQuery.language)) {
        language = routeQuery.language;
      }
    }
    routeQuery.language ? sessionStorage.setItem('language', language) : '';
    i18n.locale = language;
  }

  // 免登录信息
  if (routeQuery.token) {
    let accessToken = decodeURIComponent(routeQuery.token);
    // 老token
    if (accessToken.indexOf('@ACH') === -1) {
      let accessToken = decodeURIComponent(routeQuery.token);
      let startIndex = accessToken.indexOf('ACH');
      let endIndex = accessToken.indexOf('ACH', startIndex + 1);
      let userNo = accessToken.substring(0, endIndex);
      let token = accessToken.substring(accessToken.indexOf('ACH', endIndex) + 3, accessToken.length);
      localStorage.setItem('token', token);
      localStorage.setItem('userNo', userNo);
      if (routeQuery.id) localStorage.setItem('userId', 'ACH' + decodeURIComponent(AES_Decrypt(routeQuery.id)));
      if (routeQuery.email) {
        let email = decodeURIComponent(AES_Decrypt(routeQuery.email));
        localStorage.setItem('email', AES_Encrypt(email));
        localStorage.setItem('login_email', AES_Encrypt(email));
      }
    } else {
      // 新token
      let accessToken = routeQuery.token;
      let userNo = accessToken.substring(0, accessToken.indexOf('@ACH'));
      let userId = accessToken.substring(accessToken.indexOf('@ACH@') + 5, accessToken.indexOf('@PAY@'));
      let email = accessToken.substring(accessToken.indexOf('@PAY@') + 5, accessToken.indexOf('@IO@'));
      let token = accessToken.substring(accessToken.indexOf('@IO@') + 4, accessToken.length);
      localStorage.setItem('userNo', userNo);
      localStorage.setItem('userId', 'ACH' + AES_Decrypt(userId));
      localStorage.setItem('email', email);
      localStorage.setItem('login_email', email);
      localStorage.setItem('token', token);
    }

    // 登录后重新调用detadog监控
    detadogMonitor();
  }

  if (!routeQuery.token && routeQuery.email) {
    localStorage.setItem('email', AES_Encrypt(routeQuery.email));
    localStorage.setItem('login_email', AES_Encrypt(routeQuery.email));
  }

  //type不传默认买币
  let merchantType;
  if (routeQuery.type && routeQuery.type === 'sell' && routeQuery.appId) {
    merchantType = 'sell';
  } else if (routeQuery.type && routeQuery.type === 'buy' && routeQuery.appId) {
    merchantType = 'buy';
  } else if (!routeQuery.type && sessionStorage.getItem('merchantType') !== undefined && sessionStorage.getItem('merchantType') !== null) {
    merchantType = sessionStorage.getItem('merchantType');
  } else {
    merchantType = 'buy';
  }
  sessionStorage.setItem('merchantType', merchantType);
  //api商户
  let orderNo = routeQuery.orderNo ? routeQuery.orderNo : '';
  if (orderNo !== '') {
    let newMerchantInfo = {
      //商户类型
      merchantType: 'api', //api、page
      //商户状态
      merchantStatus: true,
      //api商户信息｜page商户信息
      merchantQueryInfo: routeInfo.query,
      //商户地址栏信息
      merchantFullPath: routeInfo.fullPath
    };
    $store.commit('buyCryptoMerchant/set_merchantInfo', newMerchantInfo);
  }
  if (orderNo !== '' && merchantType === 'buy') {
    let merchantParams = {
      merchantParam_state: true,
      redirectUrl: routeQuery.redirectUrl ? routeQuery.redirectUrl : '',
      type: 'api'
    };
    sessionStorage.setItem('buyMerchantInfo', JSON.stringify(merchantParams));
  }
}

/**
 * 配置商户只能创建一次订单,创建订单后清空商户数据
 */
export function removeMerchantOrder() {
  let merchantData = JSON.parse(window.sessionStorage.getItem('buyMerchantInfo'));
  if (merchantData !== undefined && merchantData && merchantData.merchantOrderNo) {
    window.sessionStorage.removeItem('buyMerchantInfo');
  }
}

/**
 * detadog监控
 */
export function detadogMonitor() {
  if (['dev', 'test'].includes(process.env.VUE_APP_TITLE)) return;
  (function (h, o, u, n, d) {
    h = h[d] = h[d] || {
      q: [],
      onReady: function (c) {
        h.q.push(c);
      }
    };
    d = o.createElement(u);
    d.async = 1;
    d.src = n;
    n = o.getElementsByTagName(u)[0];
    n.parentNode.insertBefore(d, n);
  })(window, document, 'script', 'https://www.datadoghq-browser-agent.com/us5/v4/datadog-rum.js', 'DD_RUM');
  window.DD_RUM.onReady(function () {
    window.DD_RUM.init({
      clientToken: 'pubeac81be5f0d836ee70898824930a1110',
      applicationId: 'cee33280-e7e0-420f-b88e-a69d5901936d',
      site: 'us5.datadoghq.com',
      service: 'synthetic-on&off-ramp',
      env: 'PRO',
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      sessionSampleRate: 100,
      premiumSampleRate: 100,
      trackUserInteractions: true,
      defaultPrivacyLevel: 'mask-user-input'
    });
    window.DD_RUM.startSessionReplayRecording();
    // 登录之后上报
    if (window.localStorage.getItem('userNo')) {
      window.DD_RUM.setUser({
        id: window.localStorage.getItem('userNo') // 用户userNo
        // email: window.localStorage.getItem("email") // 用户邮箱
      });
    }
  });
}

/**
 * 获取forter cookie
 */
export async function forterCookie() {
  return await new Promise(resolve => {
    document.addEventListener('ftr:tokenReady', function (evt) {
      var token = evt.detail;
      let newToken = token.substring(0, token.indexOf('_'));
      resolve(newToken);
      // Retrieve the token to be sent to your back-end
    });
    (function () {
      var merchantConfig = {
        csp: false
      };
      var siteId = 'd7c18f1e3ae8';
      function t(t, n) {
        for (var e = t.split(''), r = 0; r < e.length; ++r) e[r] = String.fromCharCode(e[r].charCodeAt(0) + n);
        return e.join('');
      }
      function n(n) {
        return t(n, -S).replace(/%SN%/g, siteId);
      }
      function e() {
        var t = 'no' + 'op' + 'fn',
          n = 'g' + 'a',
          e = 'n' + 'ame';
        return window[n] && window[n][e] === t;
      }
      function r() {
        return !(!navigator.brave || 'function' != typeof navigator.brave.isBrave);
      }
      function o() {
        return document.currentScript && document.currentScript.src;
      }
      function i(t) {
        try {
          (B.ex = t), e() && -1 === B.ex.indexOf(R.uB) && (B.ex += R.uB), r() && -1 === B.ex.indexOf(R.uBr) && (B.ex += R.uBr), o() && -1 === B.ex.indexOf(R.nIL) && (B.ex += R.nIL), window.ftr__snp_cwc || (B.ex += R.s), F(B);
        } catch (t) {}
      }
      function c(t, n) {
        function e(o) {
          try {
            o.blockedURI === t && (n(), document.removeEventListener(r, e));
          } catch (t) {
            document.removeEventListener(r, e);
          }
        }
        var r = 'securitypolicyviolation';
        document.addEventListener(r, e),
          setTimeout(function () {
            document.removeEventListener(r, e);
          }, 2 * 60 * 1e3);
      }
      function a(t, n, e, r) {
        var o = !1;
        (t = 'https://' + t),
          c(t, function () {
            r(!0), (o = !0);
          });
        var i = document.createElement('script');
        (i.onerror = function () {
          if (!o)
            try {
              r(!1), (o = !0);
            } catch (t) {}
        }),
          (i.onload = e),
          (i.type = 'text/javascript'),
          (i.id = 'ftr__script'),
          (i.async = !0),
          (i.src = t);
        var a = document.getElementsByTagName('script')[0];
        a.parentNode.insertBefore(i, a);
      }
      function u(t, n, e, r) {
        var o = !1,
          i = new XMLHttpRequest();
        if (
          (c('https:' + t, function () {
            e(new Error('CSP Violation'), !0), (o = !0);
          }),
          'withCredentials' in i)
        )
          i.open('GET', t, !0);
        else {
          if ('undefined' == typeof XDomainRequest) return;
          (i = new XDomainRequest()), i.open('GET', t);
        }
        Object.keys(r).forEach(function (t) {
          i.setRequestHeader(t, r[t]);
        }),
          (i.onload = function () {
            'function' == typeof n && n(i);
          }),
          (i.onerror = function (t) {
            if ('function' == typeof e && !o)
              try {
                e(t, !1), (o = !0);
              } catch (t) {}
          }),
          (i.onprogress = function () {}),
          (i.ontimeout = function () {
            'function' == typeof e && e('tim' + 'eo' + 'ut', !1);
          }),
          setTimeout(function () {
            i.send();
          }, 0);
      }
      function d(t, siteId, n) {
        function e(t) {
          var n = t.toString(16);
          return n.length % 2 ? '0' + n : n;
        }
        function r(t) {
          if (t <= 0) return '';
          for (var n = '0123456789abcdef', e = '', r = 0; r < t; r++) e += n[Math.floor(Math.random() * n.length)];
          return e;
        }
        function o(t) {
          for (var n = '', r = 0; r < t.length; r++) n += e(t.charCodeAt(r));
          return n;
        }
        function i(t) {
          for (var n = t.split(''), e = 0; e < n.length; ++e) n[e] = String.fromCharCode(255 ^ n[e].charCodeAt(0));
          return n.join('');
        }
        n = n ? '1' : '0';
        var c = [];
        return (
          c.push(t),
          c.push(siteId),
          c.push(n),
          (function (t) {
            var n = 40,
              e = '';
            return t.length < n / 2 && (e = ',' + r(n / 2 - t.length - 1)), o(i(t + e));
          })(c.join(','))
        );
      }
      function f() {
        function t() {
          C && (Q(R.dUAL), setTimeout(s, E, R.dUAL));
        }
        function n(t, n) {
          i(n ? R.uAS + R.uF + R.cP : R.uAS + R.uF);
        }
        window.ftr__fdad(t, n);
      }
      function s(t) {
        try {
          var n = t === R.uDF ? q : C;
          if (!n) return;
          a(
            n,
            void 0,
            function () {
              try {
                X(), i(t + R.uS);
              } catch (t) {}
            },
            function (n) {
              try {
                X(), (B.td = 1 * new Date() - B.ts), i(n ? t + R.uF + R.cP : t + R.uF), t === R.uDF && f();
              } catch (t) {
                i(R.eUoe);
              }
            }
          );
        } catch (n) {
          i(t + R.eTlu);
        }
      }
      var h = '22g6otrwjeq6qsu1forxgiurqw1qhw2vwdwxv',
        v = 'fort',
        w = 'erTo',
        l = 'ken';
      window.ftr__config = { m: merchantConfig, s: '15', si: siteId };
      var m = !1,
        p = v + w + l,
        g = 10,
        _ = {
          write: function (t, n, e, r) {
            void 0 === r && (r = !0);
            var o, i;
            if ((e ? ((o = new Date()), o.setTime(o.getTime() + 24 * e * 60 * 60 * 1e3), (i = '; expires=' + o.toGMTString())) : (i = ''), !r)) return void (document.cookie = escape(t) + '=' + escape(n) + i + '; path=/');
            for (var c = 1, a = document.domain.split('.'), u = g, d = !0; d && a.length >= c && u > 0; ) {
              var f = a.slice(-c).join('.');
              document.cookie = escape(t) + '=' + escape(n) + i + '; path=/; domain=' + f;
              var s = _.read(t);
              (null != s && s == n) || ((f = '.' + f), (document.cookie = escape(t) + '=' + escape(n) + i + '; path=/; domain=' + f)), (d = -1 === document.cookie.indexOf(t + '=' + n)), c++, u--;
            }
          },
          read: function (t) {
            var n = null;
            try {
              for (var e = escape(t) + '=', r = document.cookie.split(';'), o = 32, i = 0; i < r.length; i++) {
                for (var c = r[i]; c.charCodeAt(0) === o; ) c = c.substring(1, c.length);
                0 === c.indexOf(e) && (n = unescape(c.substring(e.length, c.length)));
              }
            } finally {
              return n;
            }
          }
        },
        y = window.ftr__config.s;
      y += 'ck';
      var T = function (t) {
          if (document.head) {
            var n = (function () {
              var n = document.createElement('link');
              return (
                n.setAttribute('rel', 'pre' + 'con' + 'nect'),
                n.setAttribute('cros' + 'sori' + 'gin', 'anonymous'),
                (n.onload = function () {
                  document.head.removeChild(n);
                }),
                (n.onerror = function (t) {
                  document.head.removeChild(n);
                }),
                n.setAttribute('href', t),
                document.head.appendChild(n),
                n
              );
            })();
            setTimeout(function () {
              document.head.removeChild(n);
            }, 3e3);
          }
        },
        S = 3,
        x = n(h || '22g6otrwjeq6qsu1forxgiurqw1qhw2vwdwxv'),
        A = t('[0Uhtxhvw0LG', -S),
        L = t('[0Fruuhodwlrq0LG', -S),
        k = t('Li0Qrqh0Pdwfk', -S),
        C,
        U = 'fgq71iruwhu1frp',
        q = n('(VQ(1' + U + '2vq2(VQ(2vfulsw1mv'),
        D = n('(VQ(1' + U + '2vqV2(VQ(2vfulsw1mv'),
        E = 10;
      window.ftr__startScriptLoad = 1 * new Date();
      var b = function (t) {
          var n = 'ft' + 'r:tok' + 'enR' + 'eady';
          window.ftr__tt && clearTimeout(window.ftr__tt),
            (window.ftr__tt = setTimeout(function () {
              try {
                delete window.ftr__tt, (t += '_tt');
                var e = document.createEvent('Event');
                e.initEvent(n, !1, !1), (e.detail = t), document.dispatchEvent(e);
              } catch (t) {}
            }, 1e3));
        },
        F = function (t) {
          var n = function (t) {
              return t || '';
            },
            e = n(t.id) + '_' + n(t.ts) + '_' + n(t.td) + '_' + n(t.ex) + '_' + n(y);
          _.write(p, e, 1825, !0), b(e), (window.ftr__gt = e);
        },
        I = function () {
          var t = _.read(p) || '',
            n = t.split('_'),
            e = function (t) {
              return n[t] || void 0;
            };
          return { id: e(0), ts: e(1), td: e(2), ex: e(3), vr: e(4) };
        },
        V = (function () {
          for (var t = {}, n = 'fgu', e = [], r = 0; r < 256; r++) e[r] = (r < 16 ? '0' : '') + r.toString(16);
          var o = function (t, n, r, o, i) {
              var c = i ? '-' : '';
              return (
                e[255 & t] +
                e[(t >> 8) & 255] +
                e[(t >> 16) & 255] +
                e[(t >> 24) & 255] +
                c +
                e[255 & n] +
                e[(n >> 8) & 255] +
                c +
                e[((n >> 16) & 15) | 64] +
                e[(n >> 24) & 255] +
                c +
                e[(63 & r) | 128] +
                e[(r >> 8) & 255] +
                c +
                e[(r >> 16) & 255] +
                e[(r >> 24) & 255] +
                e[255 & o] +
                e[(o >> 8) & 255] +
                e[(o >> 16) & 255] +
                e[(o >> 24) & 255]
              );
            },
            i = function () {
              if (window.Uint32Array && window.crypto && window.crypto.getRandomValues) {
                var t = new window.Uint32Array(4);
                return window.crypto.getRandomValues(t), { d0: t[0], d1: t[1], d2: t[2], d3: t[3] };
              }
              return { d0: (4294967296 * Math.random()) >>> 0, d1: (4294967296 * Math.random()) >>> 0, d2: (4294967296 * Math.random()) >>> 0, d3: (4294967296 * Math.random()) >>> 0 };
            },
            c = function () {
              var t = '',
                n = function (t, n) {
                  for (var e = '', r = t; r > 0; --r) e += n.charAt((1e3 * Math.random()) % n.length);
                  return e;
                };
              return (t += n(2, '0123456789')), (t += n(1, '123456789')), (t += n(8, '0123456789'));
            };
          return (
            (t.safeGenerateNoDash = function () {
              try {
                var t = i();
                return o(t.d0, t.d1, t.d2, t.d3, !1);
              } catch (t) {
                try {
                  return n + c();
                } catch (t) {}
              }
            }),
            (t.isValidNumericalToken = function (t) {
              return t && t.toString().length <= 11 && t.length >= 9 && parseInt(t, 10).toString().length <= 11 && parseInt(t, 10).toString().length >= 9;
            }),
            (t.isValidUUIDToken = function (t) {
              return t && 32 === t.toString().length && /^[a-z0-9]+$/.test(t);
            }),
            (t.isValidFGUToken = function (t) {
              return 0 == t.indexOf(n) && t.length >= 12;
            }),
            t
          );
        })(),
        R = { uDF: 'UDF', dUAL: 'dUAL', uAS: 'UAS', mLd: '1', eTlu: '2', eUoe: '3', uS: '4', uF: '9', tmos: ['T5', 'T10', 'T15', 'T30', 'T60'], tmosSecs: [5, 10, 15, 30, 60], bIR: '43', uB: 'u', uBr: 'b', cP: 'c', nIL: 'i', s: 's' };
      try {
        var B = I();
        try {
          B.id && (V.isValidNumericalToken(B.id) || V.isValidUUIDToken(B.id) || V.isValidFGUToken(B.id)) ? (window.ftr__ncd = !1) : ((B.id = V.safeGenerateNoDash()), (window.ftr__ncd = !0)),
            (B.ts = window.ftr__startScriptLoad),
            F(B),
            (window.ftr__snp_cwc = !!_.read(p)),
            window.ftr__snp_cwc || (q = D);
          for (var G = 'for' + 'ter' + '.co' + 'm', M = 'ht' + 'tps://c' + 'dn9.' + G, O = 'ht' + 'tps://' + B.id + '-' + siteId + '.cd' + 'n.' + G, j = 'http' + 's://cd' + 'n3.' + G, N = [M, O, j], H = 0; H < N.length; H++) T(N[H]);
          var P = new Array(R.tmosSecs.length),
            Q = function (t) {
              for (var n = 0; n < R.tmosSecs.length; n++) P[n] = setTimeout(i, 1e3 * R.tmosSecs[n], t + R.tmos[n]);
            },
            X = function () {
              for (var t = 0; t < R.tmosSecs.length; t++) clearTimeout(P[t]);
            };
          (window.ftr__fdad = function (n, e) {
            if (!m) {
              m = !0;
              var r = {};
              (r[k] = d(window.ftr__config.s, siteId, window.ftr__config.m.csp)),
                u(
                  x,
                  function (e) {
                    try {
                      var r = e.getAllResponseHeaders().toLowerCase();
                      if (r.indexOf(L.toLowerCase()) >= 0) {
                        var o = e.getResponseHeader(L);
                        window.ftr__altd2 = t(atob(o), -S - 1);
                      }
                      if (r.indexOf(A.toLowerCase()) < 0) return;
                      var i = e.getResponseHeader(A),
                        c = t(atob(i), -S - 1);
                      if (c) {
                        var a = c.split(':');
                        if (a && 2 === a.length) {
                          for (var u = a[0], d = a[1], f = '', s = 0, h = 0; s < 20; ++s) f += s % 3 > 0 && h < 12 ? siteId.charAt(h++) : B.id.charAt(s);
                          var v = d.split(',');
                          if (v.length > 1) {
                            var w = v[0],
                              l = v[1];
                            C = u + '/' + w + '.' + f + '.' + l;
                          }
                        }
                      }
                      n();
                    } catch (t) {}
                  },
                  function (t, n) {
                    e && e(t, n);
                  },
                  r
                );
            }
          }),
            Q(R.uDF),
            setTimeout(s, E, R.uDF);
        } catch (t) {
          i(R.mLd);
        }
      } catch (t) {}
    })();
  });
}

/**
 * 验证是否需要kyc _sumsub
 * @returns {Promise<void>} 1需要、2不需要、3调用失败
 */
export async function checkKyc(orderNnm) {
  let params = { orderNo: $store.state.buyPayments.orderNo };
  let payWayCode = $store.state.buyPayments.payMethodInfo.payWayCode;
  return await $axios.default
    .post($api.post_getKycThrough, params, '')
    .then(res => {
      // console.log('res==>5656', JSON.stringify(res));
      if (res && res.data.isKyc === true && res.data.kycLevel !== '3') {
        if (payWayCode === '10001') {
          $store.state.WhichPage = `/creditCardConfig?configPaymentFrom=userPayment`;
        } else if (['30001'].includes(payWayCode)) {
          if (orderNnm) {
            $store.state.WhichPage = `/brazilPay?orderNo=${orderNnm}`;
          } else {
            $store.state.WhichPage = '/brazilPay';
          }
        } else if (['10003', '601'].includes(payWayCode)) {
          if (orderNnm) {
            $store.state.WhichPage = `/otherWays-VA?orderNo=${orderNnm}`;
          } else {
            $store.state.WhichPage = '/otherWays-VA';
          }
        } else if (['80039', '80040', '80041', '80066', '80068', '80070', '80106', '90007', '80059'].includes(payWayCode)) {
          if (orderNnm) {
            $store.state.WhichPage = `/phpPayment?orderNo=${orderNnm}`;
          } else {
            $store.state.WhichPage = '/phpPayment';
          }
        } else if (['10004', '10005', '10006', '40001', '210', '40003', '201', '202', '203', '40002', '90001', '90002'].includes(payWayCode)) {
          if (orderNnm) {
            $store.state.WhichPage = `/otherWayPay?orderNo=${orderNnm}`;
          } else {
            $store.state.WhichPage = '/otherWayPay';
          }
        } else if (['300', '20001', '501', '701'].includes(payWayCode)) {
          if (orderNnm) {
            $store.state.WhichPage = `/binancePay?orderNo=${orderNnm}`;
          } else {
            $store.state.WhichPage = '/binancePay';
          }
        } else if (['12000'].includes(payWayCode)) {
          if (orderNnm) {
            $store.state.WhichPage = `/PSEWayPay?orderNo=${orderNnm}`;
          } else {
            $store.state.WhichPage = '/PSEWayPay';
          }
        } else if (['11000', '13000'].includes(payWayCode)) {
          if (orderNnm) {
            $store.state.WhichPage = `/pagsmilePay?orderNo=${orderNnm}`;
          } else {
            $store.state.WhichPage = '/pagsmilePay';
          }
        } else if (['18000'].includes(payWayCode)) {
          if (orderNnm) {
            $store.state.WhichPage = `/nigeriaPay?orderNo=${orderNnm}`;
          } else {
            $store.state.WhichPage = '/nigeriaPay';
          }
        } else if (['30002'].includes(payWayCode)) {
          if (orderNnm) {
            $store.state.WhichPage = `/ArgentinaPay?orderNo=${orderNnm}`;
          } else {
            $store.state.WhichPage = '/ArgentinaPay';
          }
        }
        //用户kyc信息存储
        $store.commit('userInfo/set_kycInfo_levelIndex', res.data.kycLevel);
        if (res.data.kycLevel === '1' || res.data.kycLevel === '1,2' || res.data.kycLevel === '1,2,3') {
          $store.commit('userInfo/set_kycInfo_kycTips', 1);
        } else {
          $store.commit('userInfo/set_kycInfo_kycTips', 2);
        }
        //type为applePay ｜ eWallet新加坡支付
        if (payWayCode === '10001') {
          $route.push('/kycVerification');
        } else if (payWayCode === '501') {
          $route.push('/kycVerification?type=applePay');
        } else if (['40001', '40002'].includes(payWayCode)) {
          $route.push('/kycVerification?type=eWallet');
        } else if (['30001'].includes(payWayCode)) {
          $route.push('/kycVerification?type=brazilPay');
        } else {
          $route.push('/kycVerification');
        }
        return 1;
      }
      return 2;
    })
    .catch(() => {
      return 3;
    });
}

/**
 * 验证是否需要kyc _onfido
 * @returns {Promise<void>} 1需要、2不需要、3调用失败
 */
export async function checkKyc_onfido(orderNnm) {
  let payWayCode = $store.state.buyPayments.payMethodInfo.payWayCode;
  let params = {
    orderAmount: $store.state.buyPayments.placeOrderQuery.amount,
    fiat: $store.state.buyPayments.placeOrderQuery.fiatCurrency,
    payType: payWayCode,
    businessType: 1
  };
  return await $axios.default
    .post($api.post_check, params, '')
    .then(res => {
      if ((res && res.data.kycFlag == 1) || res.data.kycFlag == 2) {
        if (res.data.userLevel == 2) {
          localStorage.setItem('getKycTokenByOnfidoWay', 'true');
          localStorage.setItem('kyc_info_onfido', JSON.stringify(res.data));
          if (payWayCode === '10001') {
            $store.state.WhichPage = `/creditCardConfig?configPaymentFrom=userPayment`;
          } else if (['30001'].includes(payWayCode)) {
            if (orderNnm) {
              $store.state.WhichPage = `/brazilPay?orderNo=${orderNnm}`;
            } else {
              $store.state.WhichPage = '/brazilPay';
            }
          } else if (['10003', '601'].includes(payWayCode)) {
            if (orderNnm) {
              $store.state.WhichPage = `/otherWays-VA?orderNo=${orderNnm}`;
            } else {
              $store.state.WhichPage = '/otherWays-VA';
            }
          } else if (['80039', '80040', '80041', '80066', '80068', '80070', '80106', '90007', '80059'].includes(payWayCode)) {
            if (orderNnm) {
              $store.state.WhichPage = `/phpPayment?orderNo=${orderNnm}`;
            } else {
              $store.state.WhichPage = '/phpPayment';
            }
          } else if (['10004', '10005', '10006', '40001', '210', '40003', '201', '202', '203', '40002', '90001', '90002'].includes(payWayCode)) {
            if (orderNnm) {
              $store.state.WhichPage = `/otherWayPay?orderNo=${orderNnm}`;
            } else {
              $store.state.WhichPage = '/otherWayPay';
            }
          } else if (['300', '20001', '501', '701'].includes(payWayCode)) {
            if (orderNnm) {
              $store.state.WhichPage = `/binancePay?orderNo=${orderNnm}`;
            } else {
              $store.state.WhichPage = '/binancePay';
            }
          } else if (['12000'].includes(payWayCode)) {
            if (orderNnm) {
              $store.state.WhichPage = `/PSEWayPay?orderNo=${orderNnm}`;
            } else {
              $store.state.WhichPage = '/PSEWayPay';
            }
          } else if (['11000', '13000'].includes(payWayCode)) {
            if (orderNnm) {
              $store.state.WhichPage = `/pagsmilePay?orderNo=${orderNnm}`;
            } else {
              $store.state.WhichPage = '/pagsmilePay';
            }
          } else if (['18000'].includes(payWayCode)) {
            if (orderNnm) {
              $store.state.WhichPage = `/nigeriaPay?orderNo=${orderNnm}`;
            } else {
              $store.state.WhichPage = '/nigeriaPay';
            }
          } else if (['30002'].includes(payWayCode)) {
            if (orderNnm) {
              $store.state.WhichPage = `/ArgentinaPay?orderNo=${orderNnm}`;
            } else {
              $store.state.WhichPage = '/ArgentinaPay';
            }
          }
          //type为applePay ｜ eWallet新加坡支付
          if (payWayCode === '10001') {
            $route.push('/kycVerification');
          } else if (payWayCode === '501') {
            $route.push('/kycVerification?type=applePay');
          } else if (['40001', '40002'].includes(payWayCode)) {
            $route.push('/kycVerification?type=eWallet');
          } else if (['30001'].includes(payWayCode)) {
            $route.push('/kycVerification?type=brazilPay');
          } else {
            $route.push('/kycVerification');
          }
          return 1;
        } else {
          localStorage.removeItem('getKycTokenByOnfidoWay');
        }
        if (payWayCode === '10001') {
          $store.state.WhichPage = `/creditCardConfig?configPaymentFrom=userPayment`;
        } else if (['30001'].includes(payWayCode)) {
          if (orderNnm) {
            $store.state.WhichPage = `/brazilPay?orderNo=${orderNnm}`;
          } else {
            $store.state.WhichPage = '/brazilPay';
          }
        } else if (['10003', '601'].includes(payWayCode)) {
          if (orderNnm) {
            $store.state.WhichPage = `/otherWays-VA?orderNo=${orderNnm}`;
          } else {
            $store.state.WhichPage = '/otherWays-VA';
          }
        } else if (['80039', '80040', '80041', '80066', '80068', '80070', '80106', '90007', '80059'].includes(payWayCode)) {
          if (orderNnm) {
            $store.state.WhichPage = `/phpPayment?orderNo=${orderNnm}`;
          } else {
            $store.state.WhichPage = '/phpPayment';
          }
        } else if (['10004', '10005', '10006', '40001', '210', '40003', '201', '202', '203', '40002', '90001', '90002'].includes(payWayCode)) {
          if (orderNnm) {
            $store.state.WhichPage = `/otherWayPay?orderNo=${orderNnm}`;
          } else {
            $store.state.WhichPage = '/otherWayPay';
          }
        } else if (['300', '20001', '501', '701'].includes(payWayCode)) {
          if (orderNnm) {
            $store.state.WhichPage = `/binancePay?orderNo=${orderNnm}`;
          } else {
            $store.state.WhichPage = '/binancePay';
          }
        } else if (['12000'].includes(payWayCode)) {
          if (orderNnm) {
            $store.state.WhichPage = `/PSEWayPay?orderNo=${orderNnm}`;
          } else {
            $store.state.WhichPage = '/PSEWayPay';
          }
        } else if (['11000', '13000'].includes(payWayCode)) {
          if (orderNnm) {
            $store.state.WhichPage = `/pagsmilePay?orderNo=${orderNnm}`;
          } else {
            $store.state.WhichPage = '/pagsmilePay';
          }
        } else if (['18000'].includes(payWayCode)) {
          if (orderNnm) {
            $store.state.WhichPage = `/nigeriaPay?orderNo=${orderNnm}`;
          } else {
            $store.state.WhichPage = '/nigeriaPay';
          }
        } else if (['30002'].includes(payWayCode)) {
          if (orderNnm) {
            $store.state.WhichPage = `/ArgentinaPay?orderNo=${orderNnm}`;
          } else {
            $store.state.WhichPage = '/ArgentinaPay';
          }
        }
        if (res.data.kycFlag == 1) {
          if (payWayCode === '10001') {
            $route.push('/kycVerify');
          } else if (payWayCode === '501') {
            $route.push('/kycVerify?type=applePay');
          } else if (['40001', '40002'].includes(payWayCode)) {
            $route.push('/kycVerify?type=eWallet');
          } else if (['30001'].includes(payWayCode)) {
            $route.push('/kycVerify?type=brazilPay');
          } else {
            // 所有都走
            $route.push('/kycVerify');
          }
        } else if (res.data.kycFlag == 2) {
          if (payWayCode === '10001') {
            $route.push('/kycStatus');
          } else if (payWayCode === '501') {
            $route.push('/kycStatus');
          } else if (['40001', '40002'].includes(payWayCode)) {
            $route.push('/kycStatus');
          } else if (['30001'].includes(payWayCode)) {
            $route.push('/kycStatus');
          } else {
            // 所有都走
            $route.push('/kycStatus');
          }
          return 1;
        }
        return 1;
      } else if (res.data.kycFlag == 0) {
        return 2;
      }
    })
    .catch(() => {
      return 3;
    });
}

export default class noData {
  constructor() {}
  isNoData(newData) {
    if (newData !== null && newData !== '' && newData !== undefined) {
      return newData;
    }
    return '';
  }
}

// 获取kyc 分流策略;
export function getKycRule(orderNo) {
  return new Promise((resolve, reject) => {
    let appId = '';
    try {
      appId = JSON.parse(window.sessionStorage.getItem('buyMerchantInfo')).appId;
    } catch (error) {
      console.log('error==>', error);
    }
    // console.log('appId==>', appId);
    let params = `orderNo=${orderNo}&appId=${appId}`;
    $axios.default
      .get($api.get_kycRule + '?' + params, '')
      .then(res => {
        if (res && res.returnCode === '0000' && res.data) {
          localStorage.setItem('kycRule', String(res.data.rule)); // "1": onfido; "2": sumsub;
          resolve(String(res.data.rule));
        } else {
          reject('get_kycRule error');
        }
      })
      .catch(() => {
        reject('get_kycRule error');
      });
  });
}

// 获取巴西 cpf
/**
 * [getBrazilCpf description]
 * @return {[String]} ["2":跳转到失败页面,"1":不做操作,继续流程,"其他失败":打印错误信息]
 *
 */
export function getBrazilCpfResult() {
  return new Promise((resolve, reject) => {
    let side = '';
    if ($store.state.homeTabstate === 'sellCrypto') {
      side = 'sell';
    } else if ($store.state.homeTabstate === 'buyCrypto') {
      side = 'buy';
    }
    let params = {
      orderNo: $store.state.buyPayments.orderNo,
      side
    };

    $axios.default
      .get($api.get_brazilCpf, params)
      .then(res => {
        if (res && res.returnCode === '0000' && res.data) {
          if (String(res.data.isBrazil) === 'true') {
            if (res.data.cpf) {
              sessionStorage.setItem('brazilPayParams', JSON.stringify(res.data));
              resolve('1'); // 巴西kyc 并且 获取到了 cpf;
            } else {
              sessionStorage.removeItem('brazilPayParams');
              resolve('2'); // 巴西kyc 没有获取到 cpf; 跳转新增的失败页面;
            }
          } else {
            sessionStorage.removeItem('brazilPayParams');
            // 不是巴西;
            resolve('2');
          }
        } else {
          sessionStorage.removeItem('brazilPayParams');
          reject('getBrazilCpf Error');
        }
      })
      .catch(error => {
        sessionStorage.removeItem('brazilPayParams');
        reject('getBrazilCpf Error');
      });
  });
}
// 获取巴西二次支付是否需要kyc以及需要跳转的path;
export async function checkPixKycIsRequired(params) {
  const kycRule = await getKycRule(params.orderNo);

  return new Promise(resolve => {
    if (kycRule === '1') {
      let new_params = {
        orderAmount: params.amount,
        fiat: params.fiatCurrency,
        payType: '30001',
        businessType: 1
      };
      $axios.default
        .post($api.post_check, new_params, '')
        .then(res => {
          try {
            if ((res.data.kycFlag == 1 || res.data.kycFlag == 2) && res.data.userLevel == 2) {
              // 需要做kyc 并且需要做的kyc等级是 2;
              localStorage.setItem('getKycTokenByOnfidoWay', 'true');
              localStorage.setItem('kyc_info_onfido', JSON.stringify(res.data));
              $store.state.WhichPage = '/brazilPay';
              resolve({
                kycIsRequired: true,
                path: '/kycVerification'
              });
            } else {
              localStorage.removeItem('getKycTokenByOnfidoWay');
            }
          } catch (e) {
            console.log(e);
          }

          $store.state.WhichPage = '/brazilPay';
          if (res && res.data.kycFlag == 1) {
            // this.$router.push('/kycVerify?type=brazilPay');
            resolve({
              kycIsRequired: true,
              path: '/kycVerify'
            });
          } else if (res.data.kycFlag == 2) {
            resolve({
              kycIsRequired: false,
              path: '/kycStatus'
            });
          } else if (res.data.kycFlag == 0) {
            resolve({
              kycIsRequired: false,
              path: '/brazilPay'
            });
          }
        })
        .catch(() => {});
    } else if (kycRule === '2') {
      let new_params = { orderNo: params.orderNo };

      $axios.default
        .post($api.post_getKycThrough, new_params, '')
        .then(res => {
          if (res && res.data.isKyc === true && res.data.kycLevel !== '3') {
            $store.state.WhichPage = '/brazilPay';
            //用户kyc信息存储
            $store.commit('userInfo/set_kycInfo_levelIndex', res.data.kycLevel);
            if (res.data.kycLevel === '1' || res.data.kycLevel === '1,2' || res.data.kycLevel === '1,2,3') {
              $store.commit('userInfo/set_kycInfo_kycTips', 1);
            } else {
              $store.commit('userInfo/set_kycInfo_kycTips', 2);
            }
            resolve({
              kycIsRequired: true,
              path: '/kycVerification'
            });
          } else {
            resolve({
              kycIsRequired: false,
              path: '/brazilPay'
            });
          }
        })
        .catch(() => {});
    }
  });
}
